module.exports = __webpack_public_path__ + "assets/img/qywh_img2.586a3639.png";